import { render, staticRenderFns } from "./CheckTick.vue?vue&type=template&id=625595b1&"
import script from "./CheckTick.vue?vue&type=script&lang=js&"
export * from "./CheckTick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports